import { Check } from 'lucide-react';
import { MobileButton } from '@/components/ui/MobileButton';
import { formatInr } from '@/app/lib/pricing';

interface OrderSuccessProps {
    documentNumber: string;
    partyName: string;
    lineCount: number;
    /** Server-computed document total, authoritative over anything shown pre-submit. */
    totalAmount: number;
    onDone: () => void;
    onViewOrders: () => void;
}

export function OrderSuccess({
    documentNumber,
    partyName,
    lineCount,
    totalAmount,
    onDone,
    onViewOrders,
}: OrderSuccessProps) {
    return (
        <div
            className="flex flex-col bg-background"
            style={{ minHeight: '100dvh', height: '100dvh' }}
        >
            <div className="flex-1 flex flex-col items-center justify-center px-8 text-center">
                <div className="w-20 h-20 rounded-full bg-green-500/10 flex items-center justify-center mb-6">
                    <Check className="h-10 w-10 text-green-500" strokeWidth={3} />
                </div>

                <h1 className="text-xl font-bold text-foreground mb-1">Order created</h1>
                <p className="text-2xl font-bold text-primary tabular-nums mb-4">
                    {documentNumber}
                </p>

                <p className="text-muted-foreground">{partyName}</p>
                <p className="text-muted-foreground">
                    {lineCount} {lineCount === 1 ? 'item' : 'items'} ·{' '}
                    <span className="font-semibold text-foreground tabular-nums">
                        {formatInr(totalAmount)}
                    </span>
                </p>

                <p className="text-sm text-muted-foreground mt-6 max-w-xs">
                    Sent to the office as a draft. Admin will review it and convert it to an
                    invoice.
                </p>
            </div>

            <div
                className="px-4 space-y-3"
                style={{ paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 16px)' }}
            >
                <MobileButton size="lg" className="w-full" onClick={onDone}>
                    Done
                </MobileButton>
                <MobileButton
                    size="lg"
                    variant="ghost"
                    className="w-full"
                    onClick={onViewOrders}
                >
                    View my orders
                </MobileButton>
            </div>
        </div>
    );
}
